export const ExtraWorkCountField = {
	DAMAGED_BOXES_PALLETS: "extra_damaged_boxes_pallets_count",
	EPL: "extra_epl_count",
	FOIL: "extra_foil_count",
	BOXES: "extra_boxes_count",
};

export const ExtraWorkCountFields = Object.values(ExtraWorkCountField);
